import React, {ReactElement} from 'react';
import {useSelector} from 'react-redux';
import {twMerge} from 'tailwind-merge';

import Nav from 'App/layout/components/nav';
import {PROPORTIONS} from 'App/layout/layoutConstants';
import {selectLayoutType} from 'App/layout/layoutSlice';

type TProps = {
  content: ReactElement;
  reparentableMap: ReactElement;
};

const WindowTemplate = ({content, reparentableMap}: TProps): ReactElement => {
  const layoutType = useSelector(selectLayoutType);

  return (
    <div className="flex h-screen flex-col">
      <Nav />
      <div
        className={twMerge(
          'w-100vw grid grow overflow-hidden',
          PROPORTIONS[layoutType],
        )}
      >
        <div className="overflow-auto">{content}</div>
        <div className="overflow-hidden border-l border-gray-300">
          {reparentableMap}
        </div>
      </div>
    </div>
  );
};

export default WindowTemplate;
